import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { auth } from '../firebase/config';

const RequireAuth = () => {
    const location = useLocation();
    const user = auth.currentUser;

    if (!user) {
        // Redirect them to the landing page, but save the current location they were trying to go to
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    // If they are logged in, render the child routes
    return <Outlet />;
};

export default RequireAuth;